import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "./AuthShell";
import api, { formatApiErrorDetail } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset your password" subtitle="We'll email you a secure reset link"
      footer={<Link className="text-[#8a6a1e] font-medium hover:underline" to="/login">Back to sign in</Link>}>
      {sent ? (
        <div className="bg-white border border-[#C79A3B]/30 rounded-xl p-6 text-sm text-[#101820]/80">
          If an account exists for <b>{email}</b>, a reset link has been sent. (In this demo the link is logged to the server console.)
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label htmlFor="email">Email address</Label>
            <Input id="email" data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 bg-white" />
          </div>
          <Button data-testid="forgot-submit-button" disabled={loading} className="w-full bg-[#101820] text-[#FAF6EE] rounded-full h-11">
            {loading ? "Sending…" : "Send reset link"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
